import {useState} from "react";
import NokiaSuddenAccelerationChart from "./charts/nokiaSuddenAccelerationChart";

interface datalabel {
  summary: summary;
  values: values[];
}
type summary = {
  totalBreachCount: number;
  affectedVehicles: number;
  highRiskDriver: number;
};
type values = {
  date: number;
  breachCount: number;
};
const vehiclesdata = {
  vehicles: {
    summary: {
      totalBreachCount: 1284,
      affectedVehicles: 35,
      highRiskDriver: 8
    },
    values: [
      {
        date: 1743465600000,
        breachCount: 100
      },
      {
        date: 1746057600000,
        breachCount: 70
      },
      {
        date: 1748736000000,
        breachCount: 200
      },
      {
        date: 1751328000000,
        breachCount: 210
      },
      {
        date: 1754006400000,
        breachCount: 60
      },
      {
        date: 1756684800000,
        breachCount: 30
      },
      {
        date: 1759276800000,
        breachCount: 90
      },
      {
        date: 1761955200000,
        breachCount: 140
      },
      {
        date: 1764547200000,
        breachCount: 180
      },
      {
        date: 1767225600000,
        breachCount: 200
      },
      {
        date: 1769904000000,
        breachCount: 60
      },
      {
        date: 1772323200000,
        breachCount: 140
      }
    ]
  }
};
export default function NokiaSuddenAcceleration() {
  const [summarySuddenAcc, setSummarySuddenAcc] = useState<summary>(
    vehiclesdata.vehicles.summary
  );
  const [valuesSuddenAcc, setValuesSuddenAcc] = useState<any>(
    vehiclesdata.vehicles.values
  );
  return (
    // main
    <div>
      {/* two row  s*/}
      <div className="flex flex-row gap-2">
        {/* one row s */}
        <div className="w-[40%] rounded-xl border border-gray-400 p-1">
          <div className="flex items-center justify-center gap-1">
            <div>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3125 0H0.9375C0.68886 0 0.450403 0.098772 0.274587 0.274587C0.098772 0.450403 0 0.68886 0 0.9375V10.3125C0 10.5611 0.098772 10.7996 0.274587 10.9754C0.450403 11.1512 0.68886 11.25 0.9375 11.25H10.3125C10.5611 11.25 10.7996 11.1512 10.9754 10.9754C11.1512 10.7996 11.25 10.5611 11.25 10.3125V0.9375C11.25 0.68886 11.1512 0.450403 10.9754 0.274587C10.7996 0.098772 10.5611 0 10.3125 0ZM9.72656 5.83945C8.95371 6.71836 8.2418 7.02832 7.59551 7.02832C6.72012 7.02832 5.96602 6.46523 5.34375 6.00059C4.21875 5.16035 3.4752 4.60547 2.22656 6.02871C2.18711 6.07862 2.13791 6.11997 2.08196 6.15025C2.02601 6.18053 1.96448 6.19911 1.90113 6.20484C1.83777 6.21058 1.7739 6.20336 1.71343 6.18363C1.65295 6.16389 1.59712 6.13205 1.54934 6.09005C1.50156 6.04804 1.46283 5.99675 1.43552 5.9393C1.4082 5.88184 1.39286 5.81943 1.39043 5.75586C1.38801 5.69229 1.39855 5.62889 1.42142 5.56952C1.44429 5.51016 1.479 5.45607 1.52344 5.41055C3.34277 3.33574 4.82461 4.44199 5.90625 5.24941C7.03125 6.08965 7.7748 6.64453 9.02344 5.22129C9.06289 5.17138 9.11209 5.13003 9.16804 5.09975C9.22399 5.06947 9.28552 5.05089 9.34887 5.04516C9.41223 5.03942 9.4761 5.04664 9.53657 5.06637C9.59705 5.08611 9.65288 5.11795 9.70066 5.15995C9.74844 5.20196 9.78717 5.25325 9.81448 5.3107C9.8418 5.36816 9.85714 5.43057 9.85956 5.49414C9.86199 5.55771 9.85145 5.62111 9.82858 5.68048C9.80571 5.73984 9.771 5.79393 9.72656 5.83945Z"
                  fill="#349C42"
                />
              </svg>
            </div>
            <div className="text-md  font-bold">Summary</div>
          </div>
          {/* three */}
          <div className="flex justify-center gap-2">
            {/* 1 */}
            <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-gray-400 p-2 ">
              <div className=" flex h-10 w-10 items-center justify-center rounded-md bg-amber-100">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 38 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6709 0C28.9756 0 37.3417 8.3118 37.3417 18.5496C37.3417 28.7874 28.9756 37.0992 18.6709 37.0992C8.36613 37.0992 0 28.7874 0 18.5496C0 8.3118 8.36613 0 18.6709 0ZM16.9205 8.69513V18.5496C16.9205 19.1293 17.2122 19.6727 17.7008 19.9988L24.7024 24.6362C25.5047 25.1724 26.5914 24.955 27.1311 24.1507Cnan nan 27.452 22.274 26.6424 21.7378L20.4212 17.6221V8.69513C20.4212 7.73142 19.6409 6.95611 18.6709 6.95611Cnan nan 16.9205 7.73142 16.9205 8.69513Z"
                    fill="#FFC727"
                  />
                </svg>
              </div>
              <div className=" text-xs font-semibold text-gray-500">
                Total Breach Count
              </div>
              <div className="text-xl font-bold">
                {summarySuddenAcc.totalBreachCount}
              </div>
              <div className="text-xs text-gray-500">vs. previous 30 days</div>
            </div>
            {/* 1 */}
            {/* 2 */}
            <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-gray-400 p-2 ">
              <div className=" flex h-10 w-10 items-center justify-center rounded-md bg-amber-100">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 40 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2358 0C10.8047 0 10.4259 0.261268 10.2626 0.659701L8.34228 5.49316L3.37166 3.9778C2.96016 3.8537 2.516 3.99087 2.2482 4.32398C1.9804 4.6571 1.94775 5.12085 2.15676 5.49316L4.73678 10.0066L0.451988 12.9589C0.099276 13.2006 -0.0705482 13.6317 0.0274273 14.0497C0.125403 14.4677 0.465051 14.7812 0.88308 14.8465L6.02353 15.6434L5.65775 20.8361C5.62509 21.2607 5.86023 21.6656 6.2456 21.8485C6.63097 22.0314 7.08819 21.9661 7.40825 21.6787L9.71393 19.5559L10.3344 17.2437L11.0137 14.7224C11.5363 12.7695 13.0059 11.3194 14.7956 10.7446L17.4736 6.87788C18.2117 5.81321 19.198 4.99022 20.3149 4.44809C20.2888 4.4089 20.2626 4.36971 20.23 4.33052C19.9622 3.9974 19.518 3.86023 19.1065 3.98434L14.1294 5.49316L12.209 0.659701C12.0458 0.261268 11.6669 0 11.2358 0ZM23.7571 10.0262L32.6141 12.3972C33.0386 12.5147 33.3521 12.8805 33.3848 13.3247L33.6853 17.0151L20.5239 13.488L22.6271 10.4442C22.8753 10.0784 23.3325 9.91512 23.7571 10.0262ZM19.1914 8.06665L16.0627 12.5931C14.6519 12.7891 13.4305 13.808 13.0386 15.2711L12.3593 17.7923L11.275 21.8289L10.7329 23.8472C10.4324 24.9641 11.0987 26.1072 12.209 26.4077L13.2215 26.6755C14.3384 26.9759 15.4814 26.3097 15.7819 25.1993L16.324 23.181L32.4769 27.5115L31.9348 29.5298C31.6343 30.6467 32.3005 31.7898 33.4109 32.0902L34.4233 32.358C35.5403 32.6585 36.6833 31.9923 36.9838 30.8819L37.5259 28.8636L38.6036 24.8204L39.2829 22.2992C39.6748 20.8361 39.1196 19.3469 38.0027 18.4651L37.5586 12.9785C37.3822 10.7773 35.8342 8.92883 33.7049 8.35404L24.8348 5.98957C22.6989 5.41478 20.439 6.25083 19.1849 8.06665H19.1914ZM18.081 16.6232C18.6224 16.7678 19.0455 17.1904 19.1909 17.7316C19.3363 18.2727 19.1819 18.8504 18.7859 19.2469C18.3899 19.6434 17.8125 19.7986 17.2711 19.6539C16.7297 19.5092 16.3067 19.0867 16.1613 18.5455C16.0159 18.0043 16.1702 17.4266 16.5662 17.0301C16.9622 16.6336 17.5397 16.4785 18.081 16.6232ZM32.3136 22.0575C32.4336 21.4901 32.8571 21.0352 33.4146 20.8751C33.972 20.715 34.5724 20.8757 34.9752 21.2931C35.378 21.7104 35.5175 22.316 35.3378 22.8675C35.1931 23.4089 34.7706 23.8319 34.2294 23.9773C33.6882 24.1227 33.1106 23.9683 32.714 23.5724C32.3175 23.1764 32.1624 22.5989 32.3071 22.0575H32.3136Z"
                    fill="#FFC727"
                  />
                </svg>
              </div>
              <div className=" text-xs font-semibold text-gray-500">
                Affected Vehicles
              </div>
              <div className="text-xl font-bold">
                {summarySuddenAcc.affectedVehicles}
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className="flex w-32 items-center justify-center gap-2 rounded-xl border border-amber-500 bg-amber-50 ">
                  <div className="h-2 w-2 rounded-full bg-amber-500"></div>
                  <div className="text-xs text-amber-500">21% of fleet</div>
                </div>
                <div className="text-xs text-gray-500">
                  Total 200 vehicles in fleet
                </div>
              </div>
            </div>
            {/* 2 */}
            {/* 3 */}
            <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-gray-400 p-2">
              <div className=" flex h-10 w-10 items-center justify-center rounded-md bg-amber-100">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 34 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.065 15V1.0375C17.065 0.475 17.5041 0 18.0688 0C25.8296 0 32.1223 6.26875 32.1223 14C32.1223 14.5625 31.6454 15 31.0808 15H17.065ZM0 17C0 9.41875 5.65277 3.14375 12.9869 2.14375C13.5641 2.0625 14.0535 2.525 14.0535 3.10625V18L23.8721 27.7812C24.2925 28.2 24.2611 28.8875 23.778 29.225C21.3186 30.975 18.3072 32 15.0573 32C6.74442 32 0 25.2875 0 17ZM33.0257 18C33.6092 18 34.0672 18.4875 33.9919 19.0625C33.5088 22.5562 31.8211 25.6625 29.3555 27.9563C28.979 28.3062 28.3893 28.2812 28.0254 27.9125L18.0688 18H33.0257Z"
                    fill="#FFC727"
                  />
                </svg>
              </div>
              <div className=" text-xs font-semibold text-gray-500">
                High Risk Drivers
              </div>
              <div className="text-xl font-bold">
                {summarySuddenAcc.highRiskDriver}
              </div>

              <div className="text-xs text-gray-500">
                Drivers with {/* > */}5<br />
                severe events
              </div>
            </div>
            {/* 3 */}
          </div>
          {/* three */}
        </div>
        {/* one row e */}

        {/* 2 row s */}
        <div className="w-[65%]  rounded-xl border border-gray-400  ">
          <div className="flex flex-col p-1">
            <div>
              <div className="flex items-center gap-1">
                <div>
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_4176_14827)">
                      <path
                        d="M4.99128 5.26165L6.80943 2.80172C7.98467 1.21163 8.5723 0.416585 9.12054 0.584595C9.66879 0.752606 9.66879 1.72773 9.66879 3.67798V3.86186C9.66879 4.56527 9.66879 4.91698 9.89354 5.13759L9.90544 5.14902C10.135 5.36497 10.5011 5.36497 11.2332 5.36497C12.5507 5.36497 13.2094 5.36497 13.432 5.76453C13.4357 5.77114 13.4393 5.77781 13.4428 5.78453C13.6529 6.19028 13.2715 6.70631 12.5087 7.73837L10.6906 10.1983C9.51529 11.7884 8.92765 12.5834 8.37941 12.4154C7.83116 12.2474 7.83117 11.2723 7.8312 9.32199L7.8312 9.13818C7.83121 8.43476 7.83122 8.08305 7.60646 7.86243L7.59457 7.85101C7.36496 7.63505 6.9989 7.63505 6.26679 7.63505C4.94934 7.63505 4.29061 7.63505 4.06798 7.2355C4.0643 7.22888 4.06071 7.22221 4.05723 7.21549C3.84707 6.80975 4.22848 6.29372 4.99128 5.26165Z"
                        fill="#042DA6"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_4176_14827"
                        x="0"
                        y="0.5625"
                        width="17.5"
                        height="19.875"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_4176_14827"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_4176_14827"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div className="text-md font-bold">Trends</div>
              </div>
              <div></div>
            </div>
            <div>
              <NokiaSuddenAccelerationChart valuesSuddenAcc={valuesSuddenAcc} />
            </div>
          </div>
        </div>
        {/* 2 row e */}
      </div>
      {/* two row e */}
    </div>
    //main end
  );
}
